<template>
    <div>
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    import PageComponent from '../../../mixins/PageComponent';

    export default {
        extends: PageComponent,

        data() {
            let { type, isSameAddress, isResponsible } = this.data;
            return {
                type,
                isSameAddress,
                isResponsible,
            }
        },
        computed: {
            typeOptions() {
                return Object.entries(this.data.types).map(([value,text])=>({value,text}));
            },
        },
        methods: {
            handleTypeChanged(type) {
                this.type = type;
            },
            isSameAddressChanged({ target: { checked }}) {
                this.isSameAddress = checked;
            },
            isResponsibleChanged({ target: { checked }}) {
                this.isResponsible = checked;
            },
        }
    }
</script>